import { render, staticRenderFns } from "./WorkSpace.vue?vue&type=template&id=6cb7baa8&"
import script from "./WorkSpace.vue?vue&type=script&lang=js&"
export * from "./WorkSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports